export default __webpack_public_path__ + "static/media/manual.62d73462.svg";